import { Bar, BarChart, CartesianGrid, XAxis } from 'recharts';

import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/shared/components/shadcn/chart';
import { getDateFormatByDateUnit } from '@/shared/utils/date/get-date-format-by-date-unit';
import type { CategoricalChartProps } from 'recharts/types/chart/generateCategoricalChart';
import type { ChartDataPoint } from './stack-chart-types';

type Props = {
  chartConfig: ChartConfig;
  chartData: CategoricalChartProps['data'];
  dateUnit: 'day' | 'week' | 'month';
  onBarClick: (dataPoint: ChartDataPoint, event: React.MouseEvent) => void;
};

export const StackBarChart = (props: Props) => {
  const { chartConfig, chartData, dateUnit, onBarClick } = props;
  return (
    <ChartContainer config={chartConfig} className="h-full w-full">
      <BarChart accessibilityLayer data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="date"
          tickLine={false}
          tickMargin={10}
          axisLine={false}
          tickFormatter={(value) => getDateFormatByDateUnit(value, dateUnit)}
        />
        <ChartTooltip content={<ChartTooltipContent hideLabel />} />
        <ChartLegend content={<ChartLegendContent />} />

        {Object.entries(chartConfig).map(([platform, config], index, array) => (
          <Bar
            key={platform}
            dataKey={platform}
            stackId="a"
            onClick={(data, _index, event) => {
              if (event) {
                onBarClick(data, event as React.MouseEvent);
              }
            }}
            fill={config.color}
            radius={index === array.length - 1 ? [8, 8, 0, 0] : [0, 0, 0, 0]}
          />
        ))}
      </BarChart>
    </ChartContainer>
  );
};
